import React from 'react';
import { Medal, CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function AdultOlympic() {
  return <section className="py-24 bg-ink text-off-white" data-id="element-554">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-555">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-556">
          <div data-id="element-557">
            <div className="inline-flex items-center gap-2 bg-storm-red text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-558">
              <Medal className="w-3.5 h-3.5" data-id="element-559" />
              WT / Kukkiwon
            </div>
            <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-560">
              Olympic-Style Taekwondo Training
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-561">
              Storm teaches{' '}
              <span className="text-white font-bold" data-id="element-562">
                World Taekwondo (WT) style
              </span>{' '}
              — the Olympic discipline. Curriculum is aligned with{' '}
              <span className="text-white font-bold" data-id="element-563">Kukkiwon / WT</span>{' '}
              standards, the global headquarters and governing body of
              Taekwondo.
            </p>
            <p className="text-lg text-gray-warm mb-6" data-id="element-564">
              Taekwondo became an official Olympic sport in 2000. Training that
              aligns with WT standards means real Taekwondo — not a hybrid
              martial-arts blend or a generic kickboxing program.
            </p>
            <ul className="space-y-3" data-id="element-565">
              {['WT / World Taekwondo style training', 'Kukkiwon-aligned curriculum and forms (poomsae)', 'Olympic martial art recognized worldwide', 'Real Taekwondo techniques, drills, and progression'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-566">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-567" />
                  <span className="text-off-white" data-id="element-568">{item}</span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-569">
            <img src={SITE_IMAGES.adultClasses} alt="Olympic-style Taekwondo training at Storm" className="block rounded-2xl shadow-2xl w-full object-cover aspect-[4/3]" data-id="element-570" />
          </div>
        </div>
      </div>
    </section>;
}